import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import "./cloths.css";

const Cloths = ({ nextStep, prevStep }) => {
  return (
    <Box className='cloth-container-form'>
      <Box className='top-right-character'>
        <img src='./CYPImages/WormisDryStem.png' alt='Top Right Character' className='top-right-character-image' />
      </Box>

      <Box mt={8}>
        <Box className='cloth-form-container'>
          {/* Title */}
          <Typography variant='h4' className='house-rules-title' sx={{ textAlign: "center", color: "#1976d2" }}>
            Cloths & Money
          </Typography>
          <Grid container spacing={5} mb={5}>
            <Grid item xs={12} md={6} lg={6}>
              <Box>
                <img src='./CYPImages/topleft.png' alt='Bottom Character' className='top-left-image' />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={6} mt={8}>
              <Box>
                <img src='./CYPImages/topright.png' alt='Bottom Character' className='top-left-image' />
              </Box>
            </Grid>
          </Grid>
          <Box className='centered-box'>
            <img src='./CYPImages/center.png' alt='Bottom Character' />
          </Box>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6} lg={6}>
              <Box>
                <img src='./CYPImages/leftbottom.png' alt='Bottom Character' className='top-left-image' />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={6} mt={3}>
              <Box>
                <img src='./CYPImages/rightbottom.png' alt='Bottom Character' className='top-left-image' />
              </Box>
            </Grid>
          </Grid>
          {/* Submit Button */}
          <Grid container justifyContent='center' alignItems='center' spacing={{ xs: 2, md: 4 }} mb={40}>
            <Grid item xs={12} md={3} lg={4}>
              <Button type='button' variant='contained' color='primary' onClick={prevStep} fullWidth>
                Previous
              </Button>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Button type='button' variant='contained' color='primary' onClick={nextStep} fullWidth>
                Next
              </Button>
            </Grid>
          </Grid>
          <Box className='bottom-cloths' mb={5}>
            <img src='./CYPImages/WormisStayingHome.png' alt='Bottom Character' className='bottom-cloths-image' />
          </Box>
        </Box>
      </Box>
      <Box className='bottom-cloths'>
        <img src='./CYPImages/tortoise.png' alt='left character' className='tortoise' />
      </Box>
    </Box>
  );
};

export default Cloths;
